import { render } from "./ExercisePicker.vue?vue&type=template&id=4948b65a&ts=true"
import script from "./ExercisePicker.vue?vue&type=script&lang=ts"
export * from "./ExercisePicker.vue?vue&type=script&lang=ts"

import exportComponent from "/tmp/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__